import { ProductModel } from "states/product/product.models";

export interface GetOrderReportChartModel{
  orderReportType: OrderReportType;
  branchId: number;
}
export enum OrderReportType{
  Today,
  Yesterday,
  Week,
  Month,
  LastMonth
}
export interface OrderReportChartModel{
  label:string;
  totals: Record<number,number>;
}
export interface OrderTotalReportModel{
  today:OrderReportModel;
  yesterday:OrderReportModel;
  week:OrderReportModel;
  month:OrderReportModel;
  lastMonth:OrderReportModel;
}
export interface OrderReportModel{
  totalAmount: number;
  totalOrder: number;
  products: Record<number,OrderReportTopProductModel>;
}
export interface OrderReportTopProductModel{
  totalOrder:number;
  product:ProductModel;
}